import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Button/Button';

import * as Styled from './SignUpSuccess.styled';

/**
 * `SignUpSuccess` displays a message welcoming a customer to Bombas after creating an account.
 */
const SignUpSuccess = ({ onContinueShopping }) => (
  <Styled.SignUpSuccess>
    <Styled.TopBlock>
      <Styled.Text $color="cream">
        Welcome to <Styled.Glyph $color="yellow">q</Styled.Glyph>
        <Styled.Glyph $color="cream">i</Styled.Glyph>
      </Styled.Text>
      <Styled.Text $color="yellow" align="right">
        <Styled.Glyph $color="yellow">a</Styled.Glyph>
        <Styled.Glyph $color="cream">d</Styled.Glyph>
        <Styled.Glyph $color="yellow">t</Styled.Glyph>
        <Styled.Glyph $color="cream">h</Styled.Glyph> Bombas
      </Styled.Text>
    </Styled.TopBlock>
    <Styled.BottomBlock>
      <Styled.Text align="right">
        Enjoy <Styled.Plain>all things</Styled.Plain>
      </Styled.Text>
      <Styled.Text align="right">
        <Styled.Glyph $color="seafoam">fn</Styled.Glyph> cozy{' '}
        <Styled.Plain>and</Styled.Plain>
      </Styled.Text>
      <Styled.Text align="right">
        comfortable<Styled.Plain>.</Styled.Plain>
      </Styled.Text>
    </Styled.BottomBlock>
    <Styled.BottomFill>
      <Button
        isFull
        variant="primary"
        size="large"
        onClick={onContinueShopping}
      >
        Continue
      </Button>
    </Styled.BottomFill>
  </Styled.SignUpSuccess>
);

SignUpSuccess.propTypes = {
  /**
   * A function that is called when the Continue Shopping button is clicked.
   * @param {SyntheticBaseEvent} event
   */
  onContinueShopping: PropTypes.func.isRequired
};

export default SignUpSuccess;
